export const FormPropertyTypes = {
  Radio: 0,
  Checkbox: 1,
  Textarea: 2,
  Textfield: 3,
  Resume: 4
}

export const QuestionFromMap = {
  Q1: {
    Title: '想要了解你未来的职场表现吗？',
    InternalTitle: '想要了解你未来的职场表现吗？-IM 提供',
    Description: '',
    P0: [
      {
        id: 'Q1P001',
        type: FormPropertyTypes.Radio,
        required: true,
        label:
          '(1/6) 今天是你在新公司上班的第一天。没想到早上一睁眼，却已经睡过头了。眼看时间紧张，肚子却饿得不行，家里还剩一个鸡蛋可以吃，这个时候你会：',
        options: [
          { id: 'Q1P001o1', label: 'A. 煎个美美的太阳蛋' },
          { id: 'Q1P001o2', label: 'B. 两面都煎熟就好' },
          { id: 'Q1P001o3', label: 'C. 将蛋打散再煎' },
          { id: 'Q1P001o4', label: 'D. 随便乱煎一通' }
        ]
      },
      {
        id: 'Q1P002',
        type: FormPropertyTypes.Radio,
        required: true,
        label:
          '(2/6) 你一路狂奔，风风火火地赶到了公司楼下，终于赶上了新人报到。此时你还不知道一会儿自己会被分配到哪个组。公司是一座8层的大楼，你希望自己的工作地点在哪一层？',
        options: [
          { id: 'Q1P002o1', label: 'A. 上下楼很方便的一层或二层' },
          { id: 'Q1P002o2', label: 'B. 离地面有点距离的三层或四层' },
          { id: 'Q1P002o3', label: 'C. 中间偏上的五层或六层' },
          { id: 'Q1P002o4', label: 'D. 有着绝佳视野的七层或八层' }
        ]
      },
      {
        id: 'Q1P003',
        type: FormPropertyTypes.Radio,
        required: true,
        label:
          '(3/6) 入了组，你和组员们日夜为了项目奋斗。某个项目上，每个人的资源差不多，业绩也都差异不大，但小A却明显比大家高出了一大截。你觉得他为什么会比大家高那么多？',
        options: [
          { id: 'Q1P003o1', label: 'A. 其他人很老实而小A动了手脚' },
          { id: 'Q1P003o2', label: 'B. 不为什么，大家各有各的工作方法' },
          { id: 'Q1P003o3', label: 'C. 想不出为什么' },
          { id: 'Q1P003o4', label: 'D. 不在乎' }
        ]
      },
      {
        id: 'Q1P004',
        type: FormPropertyTypes.Radio,
        required: true,
        label:
          '(4/6) 完成了一个大项目之后，你自告奋勇地邀请大家来家里吃饭，准备做几个拿手的菜，秀一把厨艺。结果却不尽人意，出了差错，你觉得最可能是以下哪种状况？',
        options: [
          { id: 'Q1P004o1', label: 'A. 菜做好了却发现忘记煮米饭，只好出去买面食代替' },
          { id: 'Q1P004o2', label: 'B. 为了精益求精地做道你最拿手的菜，误了开饭时间' },
          { id: 'Q1P004o3', label: 'C. 快速地做了一些简单的菜，以节省时间，但却没有发挥出应有的水平' },
          { id: 'Q1P004o4', label: 'D. 胡萝卜到用的时候才发现没了，赶快让同事帮忙出去买' }
        ]
      }
    ],
    P1: [
      {
        id: 'Q1P105',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '(5/6) 本次分享会你最感兴趣的环节是？',
        options: [
          { id: 'Q1P105o1', label: '普华永道介绍' },
          { id: 'Q1P105o2', label: '分享会主题演讲' },
          { id: 'Q1P105o3', label: '模拟面试' },
          { id: 'Q1P105o4', label: '普华永道 Anchor 项目介绍' },
          { id: 'Q1P105o5', label: '简历介绍' }
        ]
      },
      {
        id: 'Q1P206',
        type: FormPropertyTypes.Checkbox,
        required: false,
        label: '(6/6) 你觉得自己目前遇到的挑战有哪些？',
        options: [
          { id: 'Q1P206o01', label: '缺乏实习或者社会实战经验，不知道如何找到第一份含金量的实习' },
          { id: 'Q1P206o02', label: '缺少职场相关人脉资源，特别是有能力的人脉' },
          { id: 'Q1P206o03', label: '不了解或者缺乏职场需要的软硬技能，不知道如何在真实工作中应用知识' },
          { id: 'Q1P206o04', label: '不清楚理想的行业、职位具体做什么，需要什么能力，发展方向' },
          { id: 'Q1P206o05', label: '认为自己学历背景竞争优势不够' },
          { id: 'Q1P206o06', label: '不敢申请好的实习机会，怕实习过程中犯错，无法拿到returning offer' },
          { id: 'Q1P206o07', label: '不知道如何编写简历，在面试中更好地展现自己的能力，或者面试被拒但不知道原因' },
          { id: 'Q1P206o08', label: '毕业时间有差异，可能会错过国内秋招，春招名额有限' },
          { id: 'Q1P206o09', label: '不知道是否应该继续深造' },
          { id: 'Q1P206o10', label: '不了解中国商业运营环境、行业资讯、商业文化，或者不知道如何处理中国的人际关系' }
        ]
      },
      {
        id: 'Q1P207',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '通过填写以上信息（包括个人信息）并完成报名，我同意隐私条款中的所有条款。',
        options: [
          { id: 'Q1P207o1', label: 'A. 我同意' }
        ]
      }
    ]
  },
  Q2: {
    Title: '活动反馈',
    InternalTitle: '活动反馈-南方团队提供',
    Description: '感谢您参与普华永道You Plus系列活动。为了提供更高质量的活动，请与我们分享您对本次活动的体验。',
    P0: [
      {
        id: 'Q2P001',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '您对本次普华永道的嘉宾演讲的总体评价是',
        options: [
          { id: 'Q2P001o01', label: 'A 非常好' },
          { id: 'Q2P001o02', label: 'B 好' },
          { id: 'Q2P001o03', label: 'C 一般' },
          { id: 'Q2P001o04', label: 'D 不如预期' }
        ]
      },
      {
        id: 'Q2P002',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '在宣讲会开始前的签到环节，你有认识新朋友吗？',
        options: [
          { id: 'Q2P002o01', label: 'A 有' },
          { id: 'Q2P002o02', label: 'B 没有' }
        ]
      },
      {
        id: 'Q2P003',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '你觉得未来职业发展什么是最重要的？',
        options: [
          { id: 'Q2P003o01', label: 'A 证书' },
          { id: 'Q2P003o02', label: 'B 学历' },
          { id: 'Q2P003o03', label: 'C 能力' },
          { id: 'Q2P003o04', label: 'D人脉' }
        ]
      },
      {
        id: 'Q2P004',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '你觉得哪种重要的能力可以帮助你应对科技变革下技能重塑带来的影响？',
        options: [
          { id: 'Q2P004o01', label: 'A 商业思维' },
          { id: 'Q2P004o02', label: 'B 创新能力' },
          { id: 'Q2P004o03', label: 'C 解决问题' },
          { id: 'Q2P004o04', label: 'D 沟通及协调' }
        ]
      },
      {
        id: 'Q2P005',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '你觉得现阶段你具备应付未来职场变化的条件了吗？',
        options: [
          { id: 'Q2P005o01', label: 'A 具备' },
          { id: 'Q2P005o02', label: 'B 不具备' }
        ]
      },
      {
        id: 'Q2P006',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '你觉得你最欠缺的能力是什么？',
        options: [
          { id: 'Q2P006o01', label: 'A 自主学习能力' },
          { id: 'Q2P006o02', label: 'B 解决问题能力' },
          { id: 'Q2P006o03', label: 'C 清晰的逻辑性思维' },
          { id: 'Q2P006o04', label: 'D人际交往能力' },
          { id: 'Q2P006o05', label: 'E 沟通协调能力' }
        ]
      },
      {
        id: 'Q2P007',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '你打算如何提升欠缺的能力？',
        options: [
          { id: 'Q2P007o01', label: 'A 寻求师兄师姐帮助' },
          { id: 'Q2P007o02', label: 'B 考研深造' },
          { id: 'Q2P007o03', label: 'C 参加实训项目拓宽思维和格局' },
          { id: 'Q2P007o04', label: 'D 考证' }
        ]
      },
      {
        id: 'Q2P008',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '你觉得你最喜欢Anchor课程的哪些内容？',
        options: [
          { id: 'Q2P008o01', label: 'A  实案咨询：学习咨询必备工具，掌握解决问题的基本方法和必修技能' },
          { id: 'Q2P008o02', label: 'B 成功沟通：通过商业场景实操演练，深入了解沟通技巧，建立高效沟通模式' },
          { id: 'Q2P008o03', label: 'C 自我成长：通过专业测试进行自我认知与定位，结合职业发展打造个人品牌' },
          { id: 'Q2P008o04', label: 'D 职业发展：一对一职业指导，定制化职业发展方案，模拟面试收获求职通关技能' },
          { id: 'Q2P008o05', label: 'E 直击职场：纵览行业趋势及相关职业前景，洞悉各职能特点，实地参访深入了解企业运作模式' }
        ]
      },
      {
        id: 'Q2P009',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '你觉得今天的讲座最大的收获是什么？',
        options: [
          { id: 'Q2P009o01', label: 'A 职业洞察' },
          { id: 'Q2P009o02', label: 'B 行业信息' },
          { id: 'Q2P009o03', label: 'C 职业规划的重要性' },
          { id: 'Q2P009o04', label: 'D 了解了自己的不足和未来目标' }
        ]
      },
      {
        id: 'Q2P010',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '你是否已经建立对未来职业的规划，并为之努力？',
        options: [
          { id: 'Q2P010o01', label: 'A 有' },
          { id: 'Q2P010o02', label: 'B 没有' }
        ]
      }
    ],
    P1: [
      {
        id: 'Q2P111',
        type: FormPropertyTypes.Textarea,
        required: true,
        label: '你现阶段最大的困惑是什么？',
        options: [
        ]
      },
      {
        id: 'Q2P112',
        type: FormPropertyTypes.Textarea,
        required: true,
        label: '对于本次活动，您有什么建议吗？',
        options: [

        ]
      }
    ],
    P2: [
      {
        id: 'Q2P201',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '通过填写以上信息（包括个人信息）并完成报名，我同意隐私条款中的所有条款。',
        options: [
          { id: 'Q2P201o1', label: 'A. 我同意' }
        ]
      }
    ]
  },
  Q3: {
    Title:
      '我要报名 | 普华永道 You Plus Anchor 一对一职业规划咨询',
    InternalTitle: '一对一职业规划咨询-IM提供',
    Description: '带领你了解萌新学生到职场狠角的转变，<br/>完成上至心理及思维，下至软硬技能的全副武装，<br>为秋招做好准备，有的放矢。<br><br>带你了解国内市场、行业趋势及职业前景,<br> 完成个人360°人生职涯规划,<br>    提前接受来自作为雇佣方的普华永道的面试及职场挑战。<br>',
    P0: [
      {
        id: 'Q3P001',
        type: FormPropertyTypes.Textarea,
        required: false,
        label: '您在这次活动中的 key take-away point 是什么？',
        options: [
        ]
      },
      {
        id: 'Q3P002',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '通过填写以上信息（包括个人信息）并完成报名，我同意隐私条款中的所有条款。',
        options: [
          { id: 'Q3P002o1', label: 'A. 我同意' }
        ]
      }
    ]
  },
  Q4: {
    Title:
      '活动反馈',
    InternalTitle: '活动反馈-中部团队提供',
    Description: '感谢参与普华永道You Plus系列活动。为了提供更高质量的活动，请与我们分享您对本次活动的体验。',
    P0: [
      {
        id: 'Q4P001',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '你对本次普华永道的嘉宾演讲的总体评价是? ',
        options: [
          { id: 'Q4P001o1', label: '非常好' },
          { id: 'Q4P001o2', label: '好' },
          { id: 'Q4P001o3', label: '一般' },
          { id: 'Q4P001o4', label: '不如预期' }
        ]
      },
      {
        id: 'Q4P002',
        type: FormPropertyTypes.Textarea,
        required: false,
        label: '对于本次活动，你有什么建议吗？ ',
        options: [
        ]
      },
      {
        id: 'Q4P003',
        type: FormPropertyTypes.Textarea,
        required: false,
        label: '这场活动你最大的收获是什么？',
        options: [
        ]
      },
      {
        id: 'Q4P004',
        type: FormPropertyTypes.Textarea,
        required: false,
        label: '你是否建立对未来职业的规划？如有， 是怎么样的规划？',
        options: [
        ]
      },
      {
        id: 'Q4P005',
        type: FormPropertyTypes.Textarea,
        required: false,
        label: '你现阶段最大的困惑是？',
        options: [
        ]
      },
      {
        id: 'Q4P006',
        type: FormPropertyTypes.Textarea,
        required: false,
        label: '你最需要的求职相关的帮助是？',
        options: [
        ]
      },
      {
        id: 'Q4P007',
        type: FormPropertyTypes.Textarea,
        required: false,
        label: '你希望未来在普华永道You Plus后续活动中获得哪些信息？',
        options: [
        ]
      },
      {
        id: 'Q4P008',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '你是否想申请PwC You Plus的一对一简历修改和职业辅导？ ',
        options: [
          { id: 'Q4P008o1', label: '是' },
          { id: 'Q4P008o2', label: '否' }
        ]
      },
      {
        id: 'Q4P009',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '你是否想报名参加PwC You Plus后续线下活动？ 为什么？',
        options: [
          { id: 'Q4P009o1', label: '是' },
          { id: 'Q4P009o2', label: '否' }
        ]
      },
      {
        id: 'Q4P010',
        type: FormPropertyTypes.Textarea,
        required: false,
        label: '为什么？',
        options: [
        ]
      }],
    P1: [
      {
        id: 'Q4P101',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '通过填写以上信息（包括个人信息）并完成报名，我同意隐私条款中的所有条款。',
        options: [
          { id: 'Q4P101', label: 'A. 我同意' }
        ]
      }
    ]
  },
  Q5: {
    Title: '大学生职业发展教师培训公开课调查问卷',
    InternalTitle: '大学生职业发展教师培训公开课调查问卷',
    Description: '感谢您对普华永道You Plus的关注。为了更全面的了解大学生就业指导中心教师的培训需求，并将普华永道的专业服务经验分享给各位，我们邀请您参与填写本次问卷。',
    P0: [
      {
        id: 'Q5P001',
        type: FormPropertyTypes.Checkbox,
        required: true,
        label:
          '1. 您在目前日常就业指导工作中，哪个行业是本校学生最感兴趣的？您最希望深入了解的行业是?(多选题)',
        options: [
          { id: 'Q5P001o1', label: 'A. 金融' },
          { id: 'Q5P001o2', label: 'B. 咨询' },
          { id: 'Q5P001o3', label: 'C. 快消零售' },
          { id: 'Q5P001o4', label: 'D. TMT' },
          { id: 'Q5P001o5', label: 'E. 其他' }
        ]
      },
      {
        id: 'Q5P002',
        type: FormPropertyTypes.Textfield,
        required: false,
        label:
          '其他感兴趣的行业请注明',
        options: [
        ]
      },
      {
        id: 'Q5P003',
        type: FormPropertyTypes.Checkbox,
        required: true,
        label:
          '2. 您在目前日常就业指导工作中，哪个职能是本校学生最感兴趣的？您最希望深入了解的职能部门是?(多选题)',
        options: [
          { id: 'Q5P003o1', label: 'A. 财务' },
          { id: 'Q5P003o2', label: 'B. 市场营销' },
          { id: 'Q5P003o3', label: 'C. 运营' },
          { id: 'Q5P003o4', label: 'D. 人力资源' },
          { id: 'Q5P003o5', label: 'E. 行政' },
          { id: 'Q5P003o6', label: 'F. 学习与发展' },
          { id: 'Q5P003o7', label: 'G. 其他' }
        ]
      },
      {
        id: 'Q5P004',
        type: FormPropertyTypes.Textfield,
        required: false,
        label:
          '其他感兴趣的职能部门请注明',
        options: [
        ]
      },
      {
        id: 'Q5P005',
        type: FormPropertyTypes.Checkbox,
        required: true,
        label:
          '3. 在本期大学生职业发展教师培训过程中，您希望听到哪些类型的培训?(多选题)',
        options: [
          { id: 'Q5P005o1', label: 'A. 答疑解惑，分析、解答求职各个环节的常见问题' },
          { id: 'Q5P005o2', label: 'B. 高管讲座，从管理者视角分享企业用人标准' },
          { id: 'Q5P005o3', label: 'C. 互动教学，通过模拟实操体验面试及职场环境' },
          { id: 'Q5P005o4', label: 'D. 技巧介绍，罗列、讲解职场通用基本技能' },
          { id: 'Q5P005o5', label: 'E. 其他' }
        ]
      },
      {
        id: 'Q5P006',
        type: FormPropertyTypes.Textfield,
        required: false,
        label:
          '其他类型的培训请注明',
        options: [
        ]
      },
      {
        id: 'Q5P007',
        type: FormPropertyTypes.Checkbox,
        required: true,
        label:
          '4. 在就业指导工作中，您最想提升的职业生涯辅导技能是?(多选题)',
        options: [
          { id: 'Q5P007o01', label: 'A. 自我认知与定位' },
          { id: 'Q5P007o02', label: 'B. 个人职业发展设定' },
          { id: 'Q5P007o03', label: 'C. 简历撰写' },
          { id: 'Q5P007o04', label: 'D. 面试技巧提升' },
          { id: 'Q5P007o05', label: 'E. 职业的未来发展路径' },
          { id: 'Q5P007o06', label: 'F. 行业目前的发展动态' },
          { id: 'Q5P007o07', label: 'G. 行业未来的发展趋势' },
          { id: 'Q5P007o08', label: 'H. 行业内的职业发展机遇' },
          { id: 'Q5P007o09', label: 'I. 以上都会考虑' },
          { id: 'Q5P007o10', label: 'J. 其他' }
        ]
      },
      {
        id: 'Q5P008',
        type: FormPropertyTypes.Textfield,
        required: false,
        label:
          '其他辅导技能请注明',
        options: [
        ]
      },
      {
        id: 'Q5P009',
        type: FormPropertyTypes.Checkbox,
        required: true,
        label:
          '5. ⾯对未来可能遇到的就业压⼒，您会推荐学生⾃我提升的途径是?(多选题)',
        options: [
          { id: 'Q5P009o01', label: 'A. 提升专业能力，继续进⾏学历学习，增长知识' },
          { id: 'Q5P009o02', label: 'B. 提升专业技能，考取各类技术证书' },
          { id: 'Q5P009o03', label: 'C. 提升实践经验，增加工作实践' },
          { id: 'Q5P009o04', label: 'D. 提升面试技巧，尽可能投简历参加应聘' },
          { id: 'Q5P009o05', label: 'E. 寻求人脉，联络⼀切可能的关系' },
          { id: 'Q5P009o06', label: 'F. 提前学习商业社会必备的职场商务技能' },
          { id: 'Q5P009o07', label: 'G. 加强理论知识与社会实践应用的转化，最大化提升职场竞争力' },
          { id: 'Q5P009o09', label: 'H. 以上都会考虑' },
          { id: 'Q5P009o10', label: 'I. 其他' }
        ]
      },
      {
        id: 'Q5P010',
        type: FormPropertyTypes.Textfield,
        required: false,
        label:
          '其他提升的途径请注明',
        options: [
        ]
      }
    ],
    P1: [
      {
        id: 'Q5P207',
        type: FormPropertyTypes.Radio,
        required: true,
        label: '通过填写以上信息（包括个人信息）并完成报名，我同意隐私条款中的所有条款。',
        options: [
          { id: 'Q5P207o1', label: 'A. 我同意' }
        ]
      }
    ]
  }
}
